import { createSelector } from 'reselect';
import { isCIAMSyncFlag, isRefreshAssets } from '../../../GeneralFilter/GeneralFilterModal/selectors';

const getHierarchyConditionIndicesData = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.data || {};
};

const getHierarchyConditionIndicesLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.loadingStatus;
};

const getHierarchyInitialLoadDone = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.hierarchy?.initialLoadDone;
};

const getAssetOverviewData = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.data || {};
};

const getAssetOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.loadingStatus;
};

const getAssetInitialLoadDone = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assets?.initialLoadDone;
};

const getSelectedFilters = ({ generalFilter }) => {
    return generalFilter?.selectedFilters;
};

export const getModel = createSelector(
    [
        getHierarchyConditionIndicesData,
        getHierarchyConditionIndicesLoadingStatus,
        getHierarchyInitialLoadDone,
        getAssetOverviewData,
        getAssetOverviewLoadingStatus,
        getAssetInitialLoadDone,
        isCIAMSyncFlag,
        isRefreshAssets,
        getSelectedFilters
    ],
    (
        hierarchyData,
        hierarchyLoadingStatus,
        hierarchyInitialLoadDone,
        assetOverviewData,
        assetOverviewLoadingStatus,
        assetInitialLoadDone,
        refeshCIAMSync,
        refreshAssets,
        selectedFilters
    ) => {
        return {
            hierarchyData,
            hierarchyLoadingStatus,
            hierarchyInitialLoadDone,
            assetOverviewData,
            assetOverviewLoadingStatus,
            assetInitialLoadDone,
            refeshCIAMSync,
            refreshAssets,
            selectedFilters
        };
    }
);
